module.exports = __webpack_public_path__ + "fonts/Sahel-Bold.02fec9f.eot";